<script>
  import { CHART_TYPES } from '@client/enums';

  import { Chart } from '../chart';

  export let data = [];
  export let height = '50px';
  export let width = 'auto';
  export let formatValue = null;
  export let formatHeader = null;

  const options = {
    responsive: true,
    legend: {
      display: false
    },
    elements: {
      line: {
        borderColor: 'rgb(0, 135, 255)',
        borderWidth: 1
      },
      point: {
        radius: 0
      }
    },
    plugins: {
      title: {
        display: false
      },
      legend: {
        display: false
      }
    },
    scales: {
      y: {
        display: false
      },
      x: {
        display: false
      }
    }
  };

  if (formatHeader) {
    options.helpers = {
      tooltipHeaderFormatter: (value) => formatHeader(value)
    };
  }

  if (formatValue) {
    options.helpers = {
      tooltipValueFormatter: (value) => formatValue(value)
    };
  }
</script>

<Chart type={CHART_TYPES.line.id} {data} {options} {height} {width} />
